// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35z07","label":"styles_label__1V-Wj"};